<article class="formEditor">
    @if (labelText()) {
        <span class="formLabel">{{ labelText() }}</span>
    }
    <lib-datepicker-dropdown
        [dateFrom]="dateFrom()"
        [dateTo]="dateTo()"
        (dateFromChange)="onDateFromChange($event)"
        (dateToChange)="onDateToChange($event)"
        [emptyDateSelected]="emptyDateSelected()"
        (emptyDateSelectedChange)="onEmptyDateSelectedChange($event)"
        [defaultTitle]="placeholderText()"
        [disabled]="readonly()"
        [rangeDirection]="rangeDirection()"
        [dateRangeEnabled]="true"
        [allowSelectEmptyDate]="allowSelectEmptyDate()"
    >
    </lib-datepicker-dropdown>
</article>
